// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__F_TGu","container":"styles_container__SJtIS"};